'use strict';
const Slideout = require('slideout');

let toggler = document.querySelector('.js-toggle-slideout');
let slideout;

function initSlideout() {

	slideout = new Slideout({
		'panel': document.querySelector('.js-slideout-panel'),
		'menu': document.querySelector('.js-slideout-menu'),
		'padding': 256,
		'tolerance': 70,
		'side': 'right'
	});

	let close = (eve) => {
		eve.preventDefault();
		slideout.close();
	};

	slideout
		.on('beforeopen', function () {
			this.panel.classList.add('panel-open');
		})
		.on('open', function () {
			this.panel.addEventListener('click', close);
		})
		.on('beforeclose', function () {
			this.panel.classList.remove('panel-open');
			this.panel.removeEventListener('click', close);
		});

	const setBodyPadding = (togglerHeight) => {
		document.querySelector('body').style.paddingBottom = togglerHeight + 'px';
	};

	const fixed = document.querySelector('.js__pageheader');

	slideout.on('translate', function(translated) {
		fixed.style.transform = 'translateX(' + translated + 'px)';
	});

	slideout.on('beforeopen', function () {
		fixed.style.transition = 'transform 300ms ease';
		fixed.style.transform = 'translateX(-256px)';
	});

	slideout.on('beforeclose', function () {
		fixed.style.transition = 'transform 300ms ease';
		fixed.style.transform = 'translateX(0px)';
	});

	slideout.on('open', function () {
		fixed.style.transition = '';
	});

	slideout.on('close', function () {
		fixed.style.transition = '';
	});

// Events
	toggler.addEventListener('click', function () {
		slideout.toggle();
	});

}

export default initSlideout;
